// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"0bf65534","599":"b733ef40","856":"73c6b167"}[chunkId] + ".chunk.js";
};